import TagManager from "react-gtm-module";

function CompareSchoolsStar({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "compare_schools_star",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default CompareSchoolsStar;
